import type { SignupStep } from '../../hooks/useSignupFlow';

interface ProgressIndicatorProps {
  currentStep: SignupStep;
}

export const ProgressIndicator = ({ currentStep }: ProgressIndicatorProps) => {
  return (
    <div className="mb-14">
      <div className="flex items-center gap-3 mb-4">
        <span className="text-primary font-bold text-xs tracking-widest uppercase">
          Paso {currentStep < 10 ? `0${currentStep}` : currentStep} de 03
        </span>
        <div className="h-[1px] flex-1 bg-[#101822]/10"></div>
      </div>
      <div className="flex gap-1.5">
        <div 
          className={`h-1.5 w-1/3 rounded-full transition-all duration-300 ${
            currentStep >= 1 ? 'bg-primary' : 'bg-[#101822]/10'
          }`}
        ></div>
        <div 
          className={`h-1.5 w-1/3 rounded-full transition-all duration-300 ${
            currentStep >= 2 ? 'bg-primary' : 'bg-[#101822]/10'
          }`}
        ></div>
        <div 
          className={`h-1.5 w-1/3 rounded-full transition-all duration-300 ${
            currentStep >= 3 ? 'bg-primary' : 'bg-[#101822]/10'
          }`}
        ></div>
      </div>
    </div>
  );
};
